import RcInstanceDTO from '@robocorp/robocloud-internal-cds-sdk/lib/sdk/Types';
import { WithWorkspaceId } from '~/types/common';
import { dashboardWorkspaceApi } from '~/utils/api';

export const getAll = async ({ workspaceId }: WithWorkspaceId) =>
  dashboardWorkspaceApi.get<RcInstanceDTO.ContainerImage[]>(`/workspaces/${workspaceId}/images`);
